<template>
  <div>
    <div class="page_title justify-content-center">产品管理</div>
    <div class="firstLabel">
      <span>旗下所有产品</span>
      <button class="button add" @click="addProduct">新增产品</button>
    </div>
    <table class="table">
      <thead>
      <tr>
        <td>产品ID</td>
        <td>产品名</td>
        <td>默认价格</td>
        <td>操作</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of AllProduct" :key="item.id">
        <td>{{ item.id }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.price }}</td>
        <td v-if="item.partnerId == 'all'">
          不可操作
        </td>
        <td v-else>
          <!--          <button class="button edit" @click="goEditProduct()">修改</button>-->
          <button class="button delet" @click="deleteProduct(item)">删除</button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="nullProduct" v-if="nullAllProduct">
      暂无产品
    </div>

    <div class="secoudLabel">
      <span>网点自定义产品</span>
      <div style="display: flex;flex-direction: column">
        <select v-model="currentPos">
          <option v-for="item of posList" :key="item.id" :value="item.posId">{{ item.name }}</option>
        </select>
        <span style="font-size: 14px;font-weight: 400">暂不支持用户核验、<br/>自助录入网点的产品管理</span>
      </div>
    </div>
    <table class="table">
      <thead>
      <tr>
        <td>产品ID</td>
        <td>网点产品名</td>
        <td>网点价格</td>
        <td>开放与否</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of PosProduct" :key="item.id">
        <td>{{ item.product.id }}</td>
        <td>{{ item.p2p.productName }}</td>
        <td>{{ item.yuanPrice }}元</td>
        <td>
          <div class="checkBoxContainer">
            <input type="checkbox" :checked="item.active" @change="shelvesProduct(item)">
            <span>网点在售</span>
            <button class="button edit" @click="modifyProduct(item)">修改</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="nullProduct" v-if="nullProduct">
      暂无产品
    </div>
  </div>
</template>

<script>
import {
  queryAllProduct,
  queryGlobalProduct,
  getAllowAddProductPos,
  queryProductByPosId,
  queryzmEmployeeIndentity
} from "../graphql/api";
import {modProduct, productConfig} from "../api"
import {Dialog} from 'vant';

export default {
  name: "config_product",
  // 注入依赖，刷新页面时使用
  inject: (['reload']),
  data() {
    return {
      page: 1,
      // 服务商所有产品
      AllProduct: [],
      supported: '',
      // 网点产品列表
      PosProduct: [],
      currentPos: '',
      //   网点列表
      posList: [
        {
          id: '01',
          name: '网点1',
        }, {
          id: '02',
          name: '网点2',
        }, {
          id: '03',
          name: '网点4',
        }, {
          id: '04',
          name: '网点3',
        },
      ],


      nullAllProduct: false,
      nullPostList: false,
      nullProduct: false
    }
  },
  mounted() {
    this.getClobalProduct();
    this.getAllProduct();
    this.getProductPos();
  },

  watch: {
    currentPos: function () {
      this.nullProduct = false
      this.getProductByPosId()
    }
  },
  methods: {
    // 查询全局产品
    getClobalProduct() {
      let params = {
        page: 1,
      };
      queryGlobalProduct(params).then(res => {
        console.log('查询全局产品', res);
        try {
          for (const item of res.data.findGlobalProduct) {
            this.AllProduct.push(item);
          }
        } catch (error) {
          // this.nullAllProduct = true;
        }
      }).catch(error => {
        alert(`${error}`)
      })
    },

    // 查询商户的产品库
    getAllProduct() {
      let params = {
        partnerId: sessionStorage.getItem('partnerid'),
        page: 1
      }
      queryAllProduct(params).then(res => {
        console.log('查询商户所有产品', res);
        try {
          for (const item of res.data.queryProduct) {
            this.AllProduct.push(item)
          }
        } catch (error) {
          // this.nullAllProduct = true;
        }
      }).catch(error => {
        alert(`${error}`)
      })
    },

    // 查询满足所有条件的网点
    getProductPos() {
      let params = {
        partnerId: sessionStorage.getItem('partnerid'),
        accessTypeList: [1, 2, 3, 4]
      }
      getAllowAddProductPos(params).then(res => {
        console.log('查询所有满足条件的网点', res);
        try {
          this.posList = res.data.queryPos;
          this.currentPos = this.posList[0].posId;
          if(this.$route.params.posId){
            this.currentPos = this.$route.params.posId;
          }
        } catch (error) {
          console.log('网点查询异常', error);
          this.nullPostList = true;
          this.posList = [
            {
              id: 1,
              name: '暂无网点',
              posId: '0'
            }
          ]
          this.currentPos = this.posList[0].posId;
        }

        if (!this.nullPostList) {
          this.getProductByPosId();
        }
      }).catch(error => {
        alert(`${error}`)
      })
    },

    // 根据当前posId查相关网点产品
    getProductByPosId() {
      let params = {
        posId: this.currentPos,
        page: 1
      }
      queryProductByPosId(params).then(res => {
        console.log('根据网点查询所有产品', res);
        try {
          this.PosProduct = res.data.findP2PInfoByPosId;
          for (const item of this.PosProduct) {
            let yuanPrice = (item.p2p.realPrice / 100).toFixed(2);
            this.$set(item, 'yuanPrice', yuanPrice);
            if (item.p2p.supported == 1) {
              this.$set(item, 'active', true);
            } else if (item.p2p.supported == 0) {
              this.$set(item, 'active', false);
            }
          }
          console.log('网点产品修改后', this.PosProduct);
        } catch (err) {
          this.nullProduct = true;
        }
      }).catch(error => {
        alert(`${error}`)
      })
    },

    // 新增商品
    addProduct() {
      if (!this.nullPostList) {
        this.$router.push({
          name: 'add_product',
          params: {
            posId: this.currentPos
          }
        })
      } else {
        alert('暂无网点')
      }
      console.log('新增商品');
    },

    // 修改目标产品
    goEditProduct() {
      this.$router.push('/modify_product');
    },

    // 删除产品
    deleteProduct(item) {
      Dialog.alert({
        title: '提醒',
        message: '确定删除产品吗？'
      }).then(() => {
        let openId = sessionStorage.getItem('openid');
        let productType = item.productType;
        let params = {
          state: 2
        };
        modProduct(openId, productType, params).then(res => {
          console.log('删除产品', res);
          if (res.data.retcode == 0) {
            this.reload();
            alert('删除成功！')
          }
        }).catch(error => {
          alert(`${error}`)
        })
        console.log('删除产品');
      })
    },

    // 修改产品
    modifyProduct(item) {
      this.$router.push({
        name: 'mod_p2p_product',
        params: {
          posId: this.currentPos,
          product: item
        }
      })

    },

    // 产品上架
    shelvesProduct(item) {
      let openId = sessionStorage.getItem('openid');
      let productType = Number(item.p2p.productType);
      if (item.p2p.supported == 0) {
        this.supported = 1;
      } else {
        this.supported = 0;
      }
      let params = {
        posId: item.p2p.posId,
        productType: productType,
        supported: this.supported,
        realPrice: item.p2p.realPrice,
        realType: item.p2p.realType,
      }
      productConfig(openId, params).then(res => {
        console.log('产品上架或下架成功', res);
        if (res.data.retcode == 0) {
          alert(`修改产品状态成功！`)
        }
      }).catch(error => {
        alert(`${error}`)
      })
      console.log('产品上架');
    },

  }
}
</script>

<style src="../css/config_product.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config_product.vue